/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Button, INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IShowContactInfoInput {
    canEdit: boolean;
    email: string;
    resources: {
        editBtnLabel: string;
        emailLabel: string;
    };
    onEdit(): void;
}

export interface IShowContactInfo {
    showInfoProps: INodeProps;
    label: React.ReactNode;
    email: React.ReactNode;
    editButton?: React.ReactNode;
}

const getContactInfo = ({ canEdit, email, resources: { editBtnLabel, emailLabel }, onEdit }: IShowContactInfoInput): IShowContactInfo => ({
    showInfoProps: {
        className: `ms-checkout-guest-profile__selected-item${canEdit ? ' ms-checkout-guest-profile__selected-item--clickable' : ''}`,
        onClick: canEdit ? onEdit : undefined,
        role: canEdit ? 'button' : undefined,
        tabIndex: canEdit ? 0 : undefined,
        onKeyDown: canEdit
            ? (e: React.KeyboardEvent) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                      onEdit();
                  }
              }
            : undefined
    },
    label: (
        <label id='ms-checkout-guest-profile__label' className='ms-checkout-guest-profile__input-label'>
            {emailLabel}
        </label>
    ),
    email: <span className='ms-checkout-guest-profile__selected-email'>{email}</span>,
    editButton: canEdit && (
        <Button className='ms-checkout-guest-profile__btn-edit' title={editBtnLabel} color='primary' onClick={onEdit}>
            {editBtnLabel}
        </Button>
    )
});

export default getContactInfo;
